var _baseUrl = process.env.VUE_APP_ENDPOINT;
export let authtoken = "";
export let baseUrl = _baseUrl;